<template>
    <div class="sidebar card">
        <ul class="nav">
            <li class="nav-item mb-1">
                <a class="nav-link d-block px-2 py-1" :class="{'active': activeMenuItem === 'profile'}"
                   href="/settings/profile">Profile</a>
            </li>
            <li class="nav-item mb-1" v-if="$root.user.stripe_subscription">
                <a class="nav-link d-block px-2 py-1" :class="{'active': activeMenuItem === 'contributions'}"
                   href="/settings/contributions">Contributions</a>
            </li>
            <li class="nav-item mb-1">
                <a class="nav-link d-block px-2 py-1" :class="{'active': activeMenuItem === 'advertisement'}"
                   href="/settings/advertisement">Advertisement</a>
            </li>
            <li class="nav-item">
                <a class="nav-link d-block px-2 py-1" :class="{'active': activeMenuItem === 'billing'}"
                   href="/settings/billing">Manage Subscription</a>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'CatUxoSettingsSidebar',
        props: {
            activeMenuItem: {
                type: String,
                required: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .sidebar {
        border-radius: 6px;

        .nav-link {
            color: $c-dark-grey;
        }

        .active,
        .nav-link:hover {
            background-color: $c-orange-pale;
            color: $c-hover;
            border-radius: 6px;
            font-weight: bold;
        }

        @media (min-width: 768px) {
            width: 25%;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/shared/SettingsSidebar.vue